export default __webpack_public_path__ + "static/fifthFloor-f4c8936857e8a72332a22cd5c2399150.png";